import { IAppRoute } from "@App/types";
import { FC } from "react";
import { RouteProps as ReactRouterRouteProps } from "react-router-dom";
import { IRouteOptions } from "../../types/routes";

export type RouteProps = ReactRouterRouteProps &
  IRouteOptions & {
    fragments: IAppRoute[] | IAppRoute;
    private?: boolean;
  };

export const Route: FC<RouteProps> = () => {
  return null;
};
